import api from "./api";

export async function getKnowledgeBaseArticles(params = {}) {
  const res = await api.get("/knowledge-base/articles", { params });
  return res?.data || { count: 0, categories: [], items: [] };
}

export async function getKnowledgeBaseArticleById(articleId) {
  const res = await api.get(`/knowledge-base/articles/${articleId}`);
  return res?.data || null;
}
